import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24ed4106"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline-flex relative" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_3 = ["disabled", "aria-disabled"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" + ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BButton = _resolveComponent("BButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BButton, {
      disabled: _ctx.disabled,
      class: "rounded-full",
      onClick: _ctx.onDecreaseValue
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    _withDirectives(_createElementVNode("input", _mergeProps({ class: "mx-8" }, _ctx.$attrs, {
      disabled: _ctx.disabled,
      "aria-disabled": _ctx.disabled,
      type: "number",
      class: _ctx.classes,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event))
    }), null, 16, _hoisted_3), [
      [_vModelText, _ctx.innerValue]
    ]),
    _createVNode(_component_BButton, {
      disabled: _ctx.disabled,
      class: "rounded-full",
      onClick: _ctx.onIncreaseValue
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}